export const breakpoints = {
  mobile: 0,
  tablet: 601,
  desktop: 1025
} as const;

export type Breakpoint = keyof typeof breakpoints;
